import React from 'react';
import { BadgePercent } from 'lucide-react';
import {
  formatGBP,
  SKETCHPLAN_COMMERCIAL_RULE_SHORT,
  SKETCHPLAN_FROM_COMMERCIAL_PENCE,
  SKETCHPLAN_FROM_PRICE_PENCE,
  SKETCHPLAN_PRICING_COPY,
} from '@rehub/pricing';

interface VolumePricingWidgetProps {
  monthlyVolume?: number;
  compact?: boolean;
  customPlanRatePence?: number | null;
}

/** Logged-in pricing summary. Public volume discounts have been removed. */
const VolumePricingWidget: React.FC<VolumePricingWidgetProps> = ({ customPlanRatePence }) => {
  return (
    <div className="bg-gradient-to-br from-slate-900 to-slate-900/60 border border-teal-500/20 rounded-2xl p-5 sm:p-6">
      <div className="flex items-center gap-2.5 mb-3">
        <div className="p-2 rounded-xl bg-teal-500/15 text-teal-400">
          <BadgePercent size={18} />
        </div>
        <div>
          <h3 className="text-base font-semibold text-white leading-tight">Your Sketchplan pricing</h3>
          <p className="text-xs text-slate-400">{SKETCHPLAN_PRICING_COPY.supporting}</p>
        </div>
      </div>
      {customPlanRatePence != null ? (
        <p className="text-sm text-teal-300">
          Your agreed account rate is {formatGBP(customPlanRatePence)} per plan.
        </p>
      ) : (
        <>
          <p className="text-2xl font-bold text-white">
            From {formatGBP(SKETCHPLAN_FROM_PRICE_PENCE)}
            <span className="ml-1.5 text-sm font-medium text-slate-400">for properties up to 1,000 sq ft</span>
          </p>
          <p className="mt-1 text-sm text-slate-300">
            Commercial from {formatGBP(SKETCHPLAN_FROM_COMMERCIAL_PENCE)} ({SKETCHPLAN_COMMERCIAL_RULE_SHORT}).
            Logged-in credit costs match this cash price.
          </p>
        </>
      )}
    </div>
  );
};

export default VolumePricingWidget;
